import { useRef, useState } from 'react';

export function useStateChange<TDeps extends readonly unknown[]>(
  data: [...TDeps],
  callback: (change: SimpleChange<[...TDeps]>) => void,
) {
  const firstTime = useRef(true);
  const [prevData, setPrevData] = useState(data);

  const isChanged =
    data.length !== prevData.length ||
    data.some((item, i) => item !== prevData[i]);

  if (
    isChanged ||
    // 第一次始终会执行，与 useEffect 保持一致
    firstTime.current
  ) {
    callback({
      current: data,
      previous: prevData,
      isInitial: firstTime.current,
    });

    setPrevData(data);
    firstTime.current = false;
  }
}

interface SimpleChange<T = unknown> {
  current: T;
  previous: T;
  /**
   * 是否第一次运行
   *
   * 可以通过该参数来决定执行一些初始化工作
   */
  isInitial: boolean;
}
